(function ($, window, document) {
    'use strict';

    window.AdminKit = window.AdminKit || {};
    window.AdminKit.tables = window.AdminKit.tables || {};

    window.reloadDataTables = function () {
        $.each(window.AdminKit.tables, function (key, table) {
            table.ajax.reload(null, false);
        });
    };

    window.AdminKit.datatable = {
        init: function () {
            $('.js-data-table').each(function () {
                var $table = $(this);
                var tableId = $table.attr('id');

                if (!tableId || window.AdminKit.tables[tableId]) {
                    return;
                }

                var columns = $table.data('columns') || [
                    { data: 'index', name: 'id' },
                    { data: 'name', name: 'name' },
                    { data: 'status', name: 'status', orderable: false, searchable: false },
                    { data: 'created_at', name: 'created_at' },
                    { data: 'action', name: 'action', orderable: false, searchable: false }
                ];
                var actionTargets = $table.data('action-targets') || [2, 4];

                window.AdminKit.tables[tableId] = new DataTable(this, {
                    serverSide: true,
                    processing: true,
                    pageLength: 100,
                    lengthChange: false,
                    searching: true,
                    ordering: true,
                    dom: 'rtip',
                    ajax: function (data, callback) {
                        data.show_deleted = $('.js-toggle-deleted[data-table="#' + tableId + '"]').is(':checked') ? 1 : 0;

                        $('.js-datatable-filter[data-table="#' + tableId + '"]').each(function () {
                            data[$(this).data('param')] = $(this).val();
                        });

                        window.ajaxRequest({
                            url: $table.data('url'),
                            method: 'GET',
                            data: data,
                            showLoader: false,
                            success: callback
                        });
                    },
                    order: [[0, 'desc']],
                    columns: columns,
                    columnDefs: [
                        { targets: actionTargets, className: 'table-cell-actions' }
                    ]
                });
            });
        }
    };

    $(document).on('change', '.js-datatable-length', function () {
        var table = window.AdminKit.tables[$($(this).data('table')).attr('id')];

        if (table) {
            table.page.len(Number($(this).val())).draw();
        }
    });

    $(document).on('input', '.js-datatable-search', function () {
        var table = window.AdminKit.tables[$($(this).data('table')).attr('id')];

        if (table) {
            table.search($(this).val()).draw();
        }
    });

    $(document).on('change', '.js-toggle-deleted', function () {
        var table = window.AdminKit.tables[$($(this).data('table')).attr('id')];

        if (table) {
            table.ajax.reload();
        }
    });

    $(document).on('change', '.js-datatable-filter', function () {
        var table = window.AdminKit.tables[$($(this).data('table')).attr('id')];

        if (table) {
            table.ajax.reload();
        }
    });
})(jQuery, window, document);
